import { defaultZendeskSettings, initializeZendeskApi } from '../ZendeskService';
import { type ZendeskSettings } from '../ZendeskService/types';
import { hasZendeskApiInitialized } from '../ZendeskService/utils';

import { type HelpWidgetService } from './types';

function openKnowledgeBaseInNewTab() {
  window.open('https://support.focus.teamleader.eu', '_blank');
}

function initialize(): void {
  initializeZendeskApi().then((zE) => zE('webWidget', 'helpCenter:setSuggestions', { labels: ['default'] }));
}

function show(): void {
  if (hasZendeskApiInitialized(window)) {
    window.zE(
      'webWidget',
      'updateSettings',
      Object.assign<{}, ZendeskSettings, Partial<ZendeskSettings>>({}, window.zESettings ?? defaultZendeskSettings, {
        webWidget: {
          chat: {
            suppress: true,
          },
          contactForm: { suppress: false },
          helpCenter: { suppress: false },
        },
      }),
    );

    window.zE('webWidget', 'show');
    window.zE('webWidget', 'open');
  } else {
    openKnowledgeBaseInNewTab();
  }
}

function showContactUs(subject: string, description: string): void {
  if (hasZendeskApiInitialized(window)) {
    window.zE(
      'webWidget',
      'updateSettings',
      Object.assign<{}, ZendeskSettings, Partial<ZendeskSettings>>({}, window.zESettings ?? defaultZendeskSettings, {
        webWidget: {
          chat: {
            suppress: true,
          },
          contactForm: {
            suppress: false,
            fields: [
              { id: 'subject', prefill: { '*': subject } },
              { id: 'description', prefill: { '*': description } },
            ],
          },
          helpCenter: { suppress: true },
        },
      }),
    );

    window.zE('webWidget', 'show');
    window.zE('webWidget', 'open');
  } else {
    openKnowledgeBaseInNewTab();
  }
}

const ZendeskHelpWidgetService: HelpWidgetService = {
  initialize,
  show,
  showContactUs,
};

export default ZendeskHelpWidgetService;
